import { apiGet, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

export const activityApi = {
  listMine: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`/activity?${searchParams.toString()}`);
  },

  listUserActivity: (userId: string, params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`/activity/${userId}?${searchParams.toString()}`);
  },

  getStats: () => apiGet<{ data: Record<string, unknown> }>(`/activity/stats`),

  listAdmin: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`/activity/admin?${searchParams.toString()}`);
  },

  bulkDelete: (ids: string[]) => apiDelete<{ data: number }>(`/activity/bulk-delete`, { data: { ids } }),

  getAdminStats: () => apiGet<{ data: Record<string, unknown> }>(`/activity/stats/admin`),

  export: (format = "CSV") => apiGet<{ data: unknown }>(`/activity/export?format=${format}`),
};